import React from 'react';
import Sidebar from './Sidebar/Sidebar';
import SidebarMobile from './Sidebar/SidebarMobile';
import SidebarNav from './Sidebar/SidebarNav';
import AiAssistantModal from './AiAssistantModal';
import ChatArea from './Chat/ChatArea';
import Leaves from './Leaves';
import Tasks from './Tasks';
import NewsFeed from './NewsFeed';
import WelcomeScreenHero, { WelcomeScreenPhotoBackground } from './WelcomeScreenHero';
import { welcomeScreenFillStyle } from '../utils/welcomeScreenFillStyle';
import AllLeavesCalendar from './AllLeavesCalendar';
import CreateChatModal from './Modals/CreateChatModal';
import UserSelectionModal from './Modals/UserSelectionModal';
import ShareMessageModal from './Modals/ShareMessageModal';
import { MessengerContainer } from '../styles/GlobalStyles';
import { createPortal } from 'react-dom';
import styled from 'styled-components';
import Clock from './Common/Clock';
import OnecMassShutdownToast from './OnecMassShutdownToast';
import { useApp } from '../context/AppContext';
import { FaBars } from 'react-icons/fa';
import { FiSun } from 'react-icons/fi';
import { applyFrontendSettings, loadFrontendSettings } from '../utils/frontendSettings';
import { syncWelcomeGoogleFontLinkElements } from '../utils/googleFontsWelcome';
import {
  mergeAppTitleSettingsFromStorage,
  unionWelcomeGoogleFontFamiliesInSettings,
} from '../utils/welcomeScreenSettings';
const TopCenterClockWrap = styled.div`
  position: fixed;
  top: 8px;
  left: calc(50% + 170px); /* сдвиг вправо на 50px */
  transform: translateX(-50%);
  z-index: 100000000; /* поверх всех окон */
  padding: 10px 18px;
  border-radius: 14px;
  color: var(--clock-time-color, #eaf2f9);
  font-weight: 700;
  font-size: 1.35rem; /* крупнее */
  letter-spacing: 0.03em;
  font-variant-numeric: tabular-nums;
  box-shadow: 0 10px 28px rgba(0,0,0,0.25), 0 2px 0 rgba(255,255,255,0.06) inset;
  border: 1px solid var(--clock-border-color, rgba(255,255,255,0.16));
  background: var(--clock-background, rgba(17, 24, 39, 0.7));
  backdrop-filter: blur(8px) saturate(120%);
  -webkit-backdrop-filter: blur(8px) saturate(120%);
  pointer-events: auto; /* позволяет клик по кнопке темы */
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: var(--clock-offset-x, 0px);
  margin-top: var(--clock-offset-y, 0px);
  
  @media (max-width: 768px) {
    display: none; /* Скрываем часы на мобильных устройствах */
  }

  /* В канбане часы перекрывают доску — прячем только там */
  body.kanban-open & {
    display: none;
  }
`;

const ThemeButton = styled.button`
  background: linear-gradient(135deg, #22c55e 0%, #86efac 100%);
  color: #0f172a;
  border: none;
  padding: 8px 12px;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 1rem;
  box-shadow: 0 2px 8px rgba(34, 197, 94, 0.18);
  transition: all 0.2s;
  &:hover {
    background: linear-gradient(135deg, #86efac 0%, #22c55e 100%);
    transform: translateY(-2px) scale(1.04);
    box-shadow: 0 4px 16px rgba(34, 197, 94, 0.22);
  }
`;

const DEFAULT_APP_TITLE_SETTINGS = {
  welcomeScreenText: 'Issa Plus',
  welcomeScreenSubtitleText: 'Мульти - мессенджер',
  welcomeScreenImages: [],
  welcomeScreenFontSize: '2em',
  welcomeScreenFontFamily: 'Arial, sans-serif',
  welcomeScreenCustomFontUrl: '',
  welcomeScreenCustomFontDataUrl: '',
  welcomeScreenCustomFontName: '',
  welcomeScreenGoogleFontFamilies: [],
  welcomeScreenColor: '#43e97b',
  welcomeScreenUseGradient: false,
  welcomeScreenGradientStart: '#43e97b',
  welcomeScreenGradientEnd: '#2193b0',
  welcomeScreenGlowEnabled: true,
  welcomeScreenGlowColor: '#43e97b',
  welcomeScreenGlowIntensity: 12,
  welcomeScreenGlowSpread: 32,
  welcomeScreenEffectType: 'neon',
  welcomeScreenSubtitleFontSize: '1.1em',
  welcomeScreenSubtitleColor: '#fff',
  welcomeScreenTextPositionX: 0,
  welcomeScreenTextPositionY: 0,
  welcomeScreenTextScale: 100,
  welcomeScreenSubtitlePositionX: 0,
  welcomeScreenSubtitlePositionY: 0,
  welcomeScreenSubtitleScale: 100,
  welcomeScreenDescriptionText: '',
  welcomeScreenDescriptionFontSize: '1em',
  welcomeScreenDescriptionFontFamily: 'Arial, sans-serif',
  welcomeScreenDescriptionColor: '#fff',
  welcomeScreenDescriptionPositionX: 0,
  welcomeScreenDescriptionPositionY: 0,
  welcomeScreenDescriptionScale: 100,
  welcomeScreenDescriptionMaxWidth: 600,
  welcomeScreenBackgroundType: 'gradient',
  welcomeScreenBackgroundGradient: 'gradient1',
  welcomeScreenBackgroundColor: '#0f172a',
  welcomeScreenBackgroundImage: null,
  welcomeScreenSnowEnabled: false,
  welcomeScreenMobile: {},
  sidebarGoogleFontFamilies: [],
};

const getAppTitleSettingsFromStorage = () => {
  try {
    const saved = localStorage.getItem('appTitleSettings');
    if (!saved) return DEFAULT_APP_TITLE_SETTINGS;
    const parsed = JSON.parse(saved);
    return mergeAppTitleSettingsFromStorage(DEFAULT_APP_TITLE_SETTINGS, parsed);
  } catch (e) {
    return DEFAULT_APP_TITLE_SETTINGS;
  }
};

function Messenger() {
  const { state, dispatch } = useApp();
  const [showLeaves, setShowLeaves] = React.useState(false);
  const [showTasks, setShowTasks] = React.useState(false);
  const [showNews, setShowNews] = React.useState(false);
  const [showAllLeaves, setShowAllLeaves] = React.useState(false);
  const [showChat, setShowChat] = React.useState(false); // По умолчанию ничего не показываем
  const [showAiModal, setShowAiModal] = React.useState(false);
  const [appTitleSettings, setAppTitleSettings] = React.useState(getAppTitleSettingsFromStorage());
  const [isMobile, setIsMobile] = React.useState(() => {
    return window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  });
  const [showMobileSidebar, setShowMobileSidebar] = React.useState(false);
  const [showMobileSidebarNav, setShowMobileSidebarNav] = React.useState(false);
  const [frontendPresets, setFrontendPresets] = React.useState([]);
  const [personalThemeEnabled, setPersonalThemeEnabled] = React.useState(false);
  const [personalThemePresetId, setPersonalThemePresetId] = React.useState('');
  const [showThemePanel, setShowThemePanel] = React.useState(false);

  // Отслеживание изменения размера окна для определения мобильного устройства
  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Закрываем мобильный сайдбар при открытии модалок
  React.useEffect(() => {
    const handleCloseModals = () => {
      if (isMobile) {
        setShowMobileSidebar(false);
      }
    };
    window.addEventListener('close-all-modals', handleCloseModals);
    return () => window.removeEventListener('close-all-modals', handleCloseModals);
  }, [isMobile]);

  // Открываем мобильный сайдбар по событию
  React.useEffect(() => {
    const handleOpenSidebar = () => {
      if (isMobile) {
        setShowMobileSidebar(true);
      }
    };
    window.addEventListener('open-mobile-sidebar', handleOpenSidebar);
    return () => window.removeEventListener('open-mobile-sidebar', handleOpenSidebar);
  }, [isMobile]);

  React.useEffect(() => {
    const onShowAi = () => setShowAiModal(true);
    const onShowChat = () => { 
      setShowLeaves(false); 
      setShowTasks(false); 
      setShowNews(false); 
      setShowAllLeaves(false);
      setShowChat(true);
    };
    const onLeaves = () => { setShowLeaves(true); setShowTasks(false); setShowNews(false); setShowAllLeaves(false); setShowChat(false); };
    const onTasks = () => { setShowLeaves(false); setShowTasks(true); setShowNews(false); setShowAllLeaves(false); setShowChat(false); };
    const onTodo = () => { setShowLeaves(false); setShowTasks(false); setShowNews(false); setShowAllLeaves(false); setShowChat(false); };
    const onNews = () => { setShowLeaves(false); setShowTasks(false); setShowNews(true); setShowAllLeaves(false); setShowChat(false); };
    const onAllLeaves = () => { setShowLeaves(false); setShowTasks(false); setShowNews(false); setShowAllLeaves(true); setShowChat(false); };
    
    window.addEventListener('show-ai', onShowAi);
    window.addEventListener('show-chat', onShowChat);
    window.addEventListener('show-leaves', onLeaves);
    window.addEventListener('show-tasks', onTasks);
    window.addEventListener('show-todo', onTodo);
    window.addEventListener('show-news', onNews);
    window.addEventListener('show-all-leaves', onAllLeaves);
    
    window.openNewsFeed = () => {
      setShowLeaves(false);
      setShowTasks(false);
      setShowNews(true);
      setShowAllLeaves(false);
      setShowChat(false);
    };
    window.setMessengerView = (view) => {
  setShowLeaves(false);
  setShowTasks(false);
  setShowNews(false);
  setShowAllLeaves(false);
  setShowChat(view === 'chat');
    };
    
    return () => {
      window.removeEventListener('show-ai', onShowAi);
      window.removeEventListener('show-chat', onShowChat);
      window.removeEventListener('show-leaves', onLeaves);
      window.removeEventListener('show-tasks', onTasks);
      window.removeEventListener('show-todo', onTodo);
      window.removeEventListener('show-news', onNews);
      window.removeEventListener('show-all-leaves', onAllLeaves);
      delete window.openNewsFeed;
      delete window.setMessengerView;
    };
  }, []);

  React.useEffect(() => {
    const handler = (e) => {
      if (e?.detail) {
        setAppTitleSettings(mergeAppTitleSettingsFromStorage(DEFAULT_APP_TITLE_SETTINGS, e.detail));
        return;
      }
      setAppTitleSettings(getAppTitleSettingsFromStorage());
    };
    window.addEventListener('appTitleSettingsUpdated', handler);
    return () => window.removeEventListener('appTitleSettingsUpdated', handler);
  }, []);

  React.useEffect(() => {
    const loadFromServer = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) return;
        const response = await fetch('/api/app-title-settings', {
          method: 'GET',
          headers: { Authorization: `Bearer ${token}` }
        });
        if (!response.ok) return;
        const result = await response.json();
        if (result?.success && result.settings) {
          let localParsed = null;
          try {
            const ls = localStorage.getItem('appTitleSettings');
            if (ls) localParsed = JSON.parse(ls);
          } catch (e) {
            /* ignore */
          }
          const merged = unionWelcomeGoogleFontFamiliesInSettings(
            DEFAULT_APP_TITLE_SETTINGS,
            result.settings,
            localParsed
          );
          const normalized = mergeAppTitleSettingsFromStorage(DEFAULT_APP_TITLE_SETTINGS, merged);
          setAppTitleSettings(normalized);
          try {
            localStorage.setItem('appTitleSettings', JSON.stringify(normalized));
          } catch (e) {
            console.warn('⚠️ Не удалось сохранить appTitleSettings локально:', e);
          }
        }
      } catch (e) {
        console.warn('⚠️ Не удалось загрузить appTitleSettings с сервера:', e);
      }
    };
    loadFromServer();
  }, []);

  React.useEffect(() => {
    if (appTitleSettings.welcomeScreenCustomFontUrl) {
      const existingLink = document.querySelector(
        `link[data-welcome-custom-font="${appTitleSettings.welcomeScreenCustomFontUrl}"]`
      );
      if (!existingLink) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = appTitleSettings.welcomeScreenCustomFontUrl;
        link.setAttribute('data-welcome-custom-font', appTitleSettings.welcomeScreenCustomFontUrl);
        document.head.appendChild(link);
      }
    }
    if (appTitleSettings.welcomeScreenCustomFontDataUrl && appTitleSettings.welcomeScreenCustomFontName) {
      const styleId = 'welcome-custom-font-style';
      let styleTag = document.getElementById(styleId);
      if (!styleTag) {
        styleTag = document.createElement('style');
        styleTag.id = styleId;
        document.head.appendChild(styleTag);
      }
      styleTag.innerHTML = `
        @font-face {
          font-family: '${appTitleSettings.welcomeScreenCustomFontName}';
          src: url(${appTitleSettings.welcomeScreenCustomFontDataUrl});
          font-weight: normal;
          font-style: normal;
        }
      `;
    }
  }, [
    appTitleSettings.welcomeScreenCustomFontUrl,
    appTitleSettings.welcomeScreenCustomFontDataUrl,
    appTitleSettings.welcomeScreenCustomFontName
  ]);

  React.useEffect(() => {
    const root = Array.isArray(appTitleSettings.welcomeScreenGoogleFontFamilies)
      ? appTitleSettings.welcomeScreenGoogleFontFamilies
      : [];
    const mob = Array.isArray(appTitleSettings.welcomeScreenMobile?.welcomeScreenGoogleFontFamilies)
      ? appTitleSettings.welcomeScreenMobile.welcomeScreenGoogleFontFamilies
      : [];
    const sb = Array.isArray(appTitleSettings.sidebarGoogleFontFamilies)
      ? appTitleSettings.sidebarGoogleFontFamilies
      : [];
    const merged = [...new Set([...root, ...mob, ...sb].map((f) => String(f).trim()).filter(Boolean))];
    syncWelcomeGoogleFontLinkElements(merged, { preview: false });
  }, [
    appTitleSettings.welcomeScreenGoogleFontFamilies,
    appTitleSettings.welcomeScreenMobile?.welcomeScreenGoogleFontFamilies,
    appTitleSettings.sidebarGoogleFontFamilies,
  ]);

  const getUserThemeKeys = React.useCallback(() => {
    const keys = [
      state?.user?.id,
      state?.user?.userId,
      state?.user?.username
    ].filter(Boolean);
    const unique = Array.from(new Set(keys));
    if (unique.length === 0) return [];
    return unique.map((key) => `userThemePrefs:${key}`);
  }, [state?.user]);

  const getPreferredUserThemeKey = React.useCallback(() => {
    const preferred = state?.user?.id || state?.user?.userId || state?.user?.username;
    return preferred ? `userThemePrefs:${preferred}` : null;
  }, [state?.user]);

  const getAllUserThemeKeys = React.useCallback(() => {
    const keys = getUserThemeKeys();
    return [...keys, 'userThemePrefs:last'];
  }, [getUserThemeKeys]);

  const getUserThemeSettingsKeys = React.useCallback(() => {
    const keys = getUserThemeKeys().map((key) => key.replace('userThemePrefs:', 'userThemeSettings:'));
    return [...keys, 'userThemeSettings:last'];
  }, [getUserThemeKeys]);

  const latestPersonalSettingsRef = React.useRef(null);

  const saveUserThemeToServer = React.useCallback(async ({ enabled, presetId, settings }) => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return;
      await fetch('/api/user-theme', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          enabled: !!enabled,
          presetId: presetId || '',
          settings: settings || null
        })
      });
    } catch (e) {
      console.warn('⚠️ Не удалось сохранить личную тему на сервер:', e);
    }
  }, []);

  const personalThemeLoadedRef = React.useRef(false);
  const appliedLastThemeRef = React.useRef(false);

  React.useEffect(() => {
    const keys = getAllUserThemeKeys();
    if (keys.length === 0) return;
    try {
      let raw = null;
      for (const key of keys) {
        raw = localStorage.getItem(key);
        if (raw) break;
      }
      if (raw) {
        const parsed = JSON.parse(raw);
        setPersonalThemeEnabled(!!parsed.enabled);
        setPersonalThemePresetId(parsed.presetId ? String(parsed.presetId) : '');
        const preferredKey = getPreferredUserThemeKey();
        if (preferredKey && !localStorage.getItem(preferredKey)) {
          localStorage.setItem(preferredKey, raw);
        }
        localStorage.setItem('userThemePrefs:last', raw);
      } else {
        setPersonalThemeEnabled(false);
        setPersonalThemePresetId('');
      }
    } catch (e) {
      console.warn('⚠️ Не удалось загрузить личную тему:', e);
      setPersonalThemeEnabled(false);
      setPersonalThemePresetId('');
    } finally {
      personalThemeLoadedRef.current = true;
    }
  }, [getAllUserThemeKeys, getPreferredUserThemeKey]);

  React.useEffect(() => {
    const keys = getAllUserThemeKeys();
    if (keys.length === 0) return;
    if (!personalThemeLoadedRef.current) return;
    try {
      const payload = JSON.stringify({
        enabled: personalThemeEnabled,
        presetId: personalThemePresetId || ''
      });
      keys.forEach((key) => {
        localStorage.setItem(key, payload);
      });
    } catch (e) {
      console.warn('⚠️ Не удалось сохранить личную тему:', e);
    }
  }, [getAllUserThemeKeys, personalThemeEnabled, personalThemePresetId]);

  const fetchFrontendPresets = React.useCallback(async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return;
      const response = await fetch('/api/frontend-presets', {
        method: 'GET',
        headers: { Authorization: `Bearer ${token}` }
      });
      if (!response.ok) return;
      const result = await response.json();
      if (result?.success && Array.isArray(result.presets)) {
        setFrontendPresets(result.presets);
      }
    } catch (e) {
      console.warn('⚠️ Не удалось загрузить пресеты фронтенда:', e);
    }
  }, []);

  React.useEffect(() => {
    fetchFrontendPresets();
  }, [fetchFrontendPresets]);

  const GLOBAL_SETTINGS_BACKUP_KEY = 'frontendSettings_global_backup';

  const applyPersonalTheme = React.useCallback(
    (presetSettings) => {
      if (!presetSettings) return;
      let normalizedSettings = presetSettings;
      if (typeof normalizedSettings === 'string') {
        try {
          normalizedSettings = JSON.parse(normalizedSettings);
        } catch (e) {
          console.warn('⚠️ Не удалось распарсить настройки пресета:', e);
          return;
        }
      }
      if (normalizedSettings?.settings && typeof normalizedSettings.settings === 'object') {
        normalizedSettings = normalizedSettings.settings;
      }
      let mergedSettings = normalizedSettings;
      try {
        const currentGlobal = localStorage.getItem('frontendSettings');
        if (currentGlobal) {
          localStorage.setItem(GLOBAL_SETTINGS_BACKUP_KEY, currentGlobal);
        }
        const baseRaw = localStorage.getItem(GLOBAL_SETTINGS_BACKUP_KEY) || currentGlobal;
        if (baseRaw) {
          const base = JSON.parse(baseRaw);
          mergedSettings = {
            ...base,
            ...normalizedSettings,
            modals: {
              ...(base?.modals || {}),
              ...(normalizedSettings?.modals || {})
            }
          };
        }
        localStorage.setItem('frontendSettings', JSON.stringify(mergedSettings));
      } catch (e) {
        console.warn('⚠️ Не удалось сохранить личную тему в localStorage:', e);
      }
      applyFrontendSettings(mergedSettings);
      window.dispatchEvent(new CustomEvent('frontendSettingsUpdated', { detail: { source: 'personal', settings: mergedSettings } }));
      latestPersonalSettingsRef.current = mergedSettings;
      try {
        const payload = JSON.stringify(mergedSettings);
        getUserThemeSettingsKeys().forEach((key) => {
          localStorage.setItem(key, payload);
        });
      } catch (e) {
        console.warn('⚠️ Не удалось сохранить настройки личной темы:', e);
      }
    },
    [getUserThemeSettingsKeys]
  );

  React.useEffect(() => {
    const loadFromServer = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) return;
        const response = await fetch('/api/user-theme', {
          method: 'GET',
          headers: { Authorization: `Bearer ${token}` }
        });
        if (!response.ok) return;
        const result = await response.json();
        if (!result?.success) return;
        const theme = result?.theme;
        if (!theme) {
          personalThemeLoadedRef.current = true;
          return;
        }
        setPersonalThemeEnabled(!!theme.enabled);
        setPersonalThemePresetId(theme.presetId ? String(theme.presetId) : '');
        if (theme.enabled && theme.settings) {
          applyPersonalTheme(theme.settings);
        }
        personalThemeLoadedRef.current = true;
      } catch (e) {
        console.warn('⚠️ Не удалось загрузить личную тему с сервера:', e);
      }
    };
    if (state?.user) {
      loadFromServer();
    }
  }, [state?.user, applyPersonalTheme]);

  React.useEffect(() => {
    if (appliedLastThemeRef.current) return;
    if (personalThemeLoadedRef.current) return;
    try {
      const rawPrefs = localStorage.getItem('userThemePrefs:last');
      if (rawPrefs) {
        const parsed = JSON.parse(rawPrefs);
        if (typeof parsed?.enabled === 'boolean') {
          setPersonalThemeEnabled(parsed.enabled);
        }
        if (parsed?.presetId) {
          setPersonalThemePresetId(String(parsed.presetId));
        }
        if (parsed?.enabled) {
          const rawSettings = localStorage.getItem('userThemeSettings:last');
          if (rawSettings) {
            const settings = JSON.parse(rawSettings);
            applyPersonalTheme(settings);
          }
        }
      }
    } catch (e) {
      console.warn('⚠️ Не удалось загрузить последнюю личную тему:', e);
    } finally {
      appliedLastThemeRef.current = true;
    }
  }, [applyPersonalTheme]);

  const restoreGlobalTheme = React.useCallback(() => {
    try {
      const backup = localStorage.getItem(GLOBAL_SETTINGS_BACKUP_KEY);
      if (backup) {
        localStorage.setItem('frontendSettings', backup);
        localStorage.removeItem(GLOBAL_SETTINGS_BACKUP_KEY);
        const restored = JSON.parse(backup);
        applyFrontendSettings(restored);
        window.dispatchEvent(new CustomEvent('frontendSettingsUpdated', { detail: { source: 'global', settings: restored } }));
        return;
      }
    } catch (e) {
      console.warn('⚠️ Не удалось восстановить глобальную тему:', e);
    }
    const restored = loadFrontendSettings();
    applyFrontendSettings(restored);
    window.dispatchEvent(new CustomEvent('frontendSettingsUpdated', { detail: { source: 'global', settings: restored } }));
  }, []);

  React.useEffect(() => {
    if (!personalThemeEnabled) {
      restoreGlobalTheme();
      return;
    }
    const preset = frontendPresets.find((p) => String(p.id) === String(personalThemePresetId));
    if (preset?.settings) {
      applyPersonalTheme(preset.settings);
    } else if (frontendPresets.length > 0) {
      const cachedKeys = getUserThemeSettingsKeys();
      let cachedSettings = null;
      for (const key of cachedKeys) {
        const raw = localStorage.getItem(key);
        if (raw) {
          try {
            cachedSettings = JSON.parse(raw);
            break;
          } catch (e) {
            console.warn('⚠️ Не удалось распарсить кеш личной темы:', e);
          }
        }
      }
      if (cachedSettings) {
        applyPersonalTheme(cachedSettings);
      } else {
        setPersonalThemePresetId(String(frontendPresets[0].id));
      }
    }
  }, [personalThemeEnabled, personalThemePresetId, frontendPresets, applyPersonalTheme, restoreGlobalTheme, getUserThemeSettingsKeys]);

  React.useEffect(() => {
    const handler = (e) => {
      if (!personalThemeEnabled) return;
      if (e?.detail?.source === 'personal') return;
      try {
        const settingsForBackup = e?.detail?.settings || loadFrontendSettings();
        if (settingsForBackup) {
          localStorage.setItem(GLOBAL_SETTINGS_BACKUP_KEY, JSON.stringify(settingsForBackup));
        }
      } catch (err) {
        console.warn('⚠️ Не удалось обновить бэкап глобальной темы:', err);
      }
      const preset = frontendPresets.find((p) => String(p.id) === String(personalThemePresetId));
      if (preset?.settings) {
        applyPersonalTheme(preset.settings);
      }
    };
    window.addEventListener('frontendSettingsUpdated', handler);
    return () => window.removeEventListener('frontendSettingsUpdated', handler);
  }, [personalThemeEnabled, personalThemePresetId, frontendPresets, applyPersonalTheme]);

  const handleThemeToggle = React.useCallback((enabled) => {
    setPersonalThemeEnabled(enabled);
    if (!enabled) {
      saveUserThemeToServer({ enabled: false, presetId: '', settings: null });
      return;
    }
    const preset = frontendPresets.find((p) => String(p.id) === String(personalThemePresetId));
    if (preset?.settings) {
      applyPersonalTheme(preset.settings);
      saveUserThemeToServer({
        enabled: true,
        presetId: personalThemePresetId,
        settings: latestPersonalSettingsRef.current || preset.settings
      });
    }
  }, [frontendPresets, personalThemePresetId, applyPersonalTheme, saveUserThemeToServer]);

  const handlePresetChange = React.useCallback((presetId) => {
    setPersonalThemePresetId(presetId);
    if (!personalThemeEnabled) return;
    const preset = frontendPresets.find((p) => String(p.id) === String(presetId));
    if (preset?.settings) {
      applyPersonalTheme(preset.settings);
      saveUserThemeToServer({
        enabled: true,
        presetId,
        settings: latestPersonalSettingsRef.current || preset.settings
      });
    }
  }, [personalThemeEnabled, frontendPresets, applyPersonalTheme, saveUserThemeToServer]);
  const token = localStorage.getItem('token');
  // Функция для очистки базы через API
  const handleClearAll = () => {
    if (!window.confirm('Вы уверены, что хотите удалить всех пользователей, задачи и новости? Это действие необратимо!')) return;
    fetch('/api/admin/clear-all', {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${token}` }
    })
      .then(r => r.json())
      .then(res => {
        alert(res.message || 'База очищена!');
        window.location.reload();
      })
      .catch(()=>alert('Ошибка при очистке базы!'));
  };
  return (
    <MessengerContainer>
      {createPortal(
        <TopCenterClockWrap>
          <Clock />
          <div style={{ position: 'relative' }}>
            <ThemeButton onClick={() => setShowThemePanel((v) => !v)} title="Личная тема">
              <FiSun size={16} />
            </ThemeButton>
            {showThemePanel && (
              <div
                style={{
                  position: 'absolute',
                  right: 0,
                  top: '100%',
                  marginTop: 8,
                  zIndex: 1,
                  padding: '10px 12px',
                  borderRadius: 10,
                  background: 'rgba(17, 24, 39, 0.95)',
                  border: '1px solid rgba(255,255,255,0.12)',
                  minWidth: 190,
                  boxShadow: '0 8px 24px rgba(0,0,0,0.25)'
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <div style={{ fontSize: '0.75rem', color: '#b2bec3', marginBottom: 8, fontWeight: 600 }}>
                  Личная тема
                </div>
                <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: '0.78rem', color: '#e2e8f0', marginBottom: 8 }}>
                  <input
                    type="checkbox"
                    checked={personalThemeEnabled}
                    onChange={(e) => handleThemeToggle(e.target.checked)}
                    style={{ cursor: 'pointer' }}
                  />
                  Включить
                </label>
                <select
                  value={personalThemePresetId}
                  onChange={(e) => handlePresetChange(e.target.value)}
                  disabled={!personalThemeEnabled || frontendPresets.length === 0}
                  style={{
                    width: '100%',
                    padding: '6px 8px',
                    borderRadius: 8,
                    border: '1px solid rgba(255,255,255,0.2)',
                    background: personalThemeEnabled ? 'rgba(15,23,42,0.85)' : 'rgba(15,23,42,0.6)',
                    color: personalThemeEnabled ? '#e5e7eb' : '#6b7280',
                    fontSize: '0.78rem',
                    cursor: personalThemeEnabled ? 'pointer' : 'not-allowed'
                  }}
                >
                  {frontendPresets.length === 0 && (
                    <option value="">Нет пресетов</option>
                  )}
                  {frontendPresets.length > 0 && (
                    <>
                      <option value="">Выберите пресет</option>
                      {frontendPresets.map((preset) => (
                        <option key={preset.id} value={String(preset.id)}>
                          {preset.name}
                        </option>
                      ))}
                    </>
                  )}
                </select>
              </div>
            )}
          </div>
        </TopCenterClockWrap>,
        document.body
      )}
      
      {/* Кнопка открытия меню на мобильных */}
      {isMobile && (
        <button
          onClick={() => setShowMobileSidebar(true)}
          style={{
            position: 'fixed',
            top: '16px',
            left: '16px',
            zIndex: 99999,
            background: 'rgba(67,233,123,0.2)',
            border: '1px solid #43e97b',
            borderRadius: '12px',
            width: 48,
            height: 48,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            color: '#43e97b',
            fontSize: '24px',
            padding: 0,
            boxShadow: '0 4px 12px rgba(67,233,123,0.3)',
            transition: 'all 0.2s'
          }}
          title="Открыть меню"
        >
          <FaBars />
        </button>
      )}
      
      {/* Десктопный сайдбар - скрыт на мобильных */}
      {!isMobile && <Sidebar />}
      
      {/* Мобильный сайдбар */}
      {isMobile && (
        <SidebarMobile 
          open={showMobileSidebar || (!showLeaves && !showTasks && !showNews && !showChat && !showAllLeaves)} 
          onClose={() => setShowMobileSidebar(false)}
          onOpen={() => setShowMobileSidebar(true)}
          showNav={false} // Не показываем навигацию внутри SidebarMobile на мобильных
          onOpenNav={() => setShowMobileSidebarNav(true)} // Кнопка стрелки назад открывает SidebarNav
        />
      )}
      
      {/* Мобильная навигация (отдельная модалка на весь экран) */}
      {isMobile && (
        <SidebarNav 
          onCloseMobileSidebar={() => setShowMobileSidebarNav(false)}
          onOpenMobileSidebar={() => {
            setShowMobileSidebarNav(false);
            setShowMobileSidebar(true);
          }}
          isMobileNavModal={true}
          open={showMobileSidebarNav}
        />
      )}
      
      <AiAssistantModal open={showAiModal} onClose={()=>setShowAiModal(false)} />
      {showAllLeaves && <AllLeavesCalendar open={showAllLeaves} onClose={()=>setShowAllLeaves(false)} token={token} />}
      {!showAllLeaves && (showLeaves ? <Leaves token={token} /> :
       showTasks ? <Tasks token={token} /> :
       showNews ? <NewsFeed token={token} /> :
       showChat ? <ChatArea /> : 
       !isMobile && (
         <div
           style={{
             flex: 1,
             display: 'flex',
             alignItems: 'center',
             justifyContent: 'center',
             ...welcomeScreenFillStyle(appTitleSettings),
             borderRadius: '22px',
             margin: '24px 0',
             color: '#fff',
             fontSize: '1.2em',
             textAlign: 'center',
             padding: '40px',
             position: 'relative',
             overflow: 'hidden'
           }}
         >
           <WelcomeScreenPhotoBackground
             imageUrl={
               appTitleSettings.welcomeScreenBackgroundType === 'image'
                 ? appTitleSettings.welcomeScreenBackgroundImage
                 : null
             }
           />
           <WelcomeScreenHero appTitleSettings={appTitleSettings} />
         </div>
       ))}
      <CreateChatModal />
      <UserSelectionModal />
      <ShareMessageModal 
        isOpen={state.modals.shareMessage}
        onClose={() => dispatch({ type: 'TOGGLE_MODAL', payload: { modal: 'shareMessage', show: false } })}
        messageToShare={state.shareMessageData}
      />
      <OnecMassShutdownToast />
    </MessengerContainer>
  );
}

export default Messenger;